<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-4.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t("ui.game_name") }}
          DebounceInput(type="text" v-model="search" @enter="getGameNameExcludeList(true)" size="sm")
      .form-group.col-4.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-gamepad
          ProviderLookup(
            size="sm"
            type="array"
            :operatorID="operatorID"
            v-model="provider_code"
            :disabled="loading"
            @input="getGameNameExcludeList(true)"
            isAll=true
          )
      .form-group.col-3.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getGameNameExcludeList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-12.mb-1(v-if="isEditAccess")
        b-button(v-b-modal.addGameNameExclude type="button" variant="info" size="sm")
          i.fa.fa-plus
          span.ml-1 {{ $t("ui.combine.add_game_exclude") }}
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="5%")
                  span #
                th.sortable
                  span(:title="$t('ui.game_name')") {{ $t('ui.game_name') }}                  
                th(width="13%")
                  span(:title="$t('ui.provider_code')") {{ $t("ui.provider_code") }}
                th.sortable(width="12%")
                  span(:title="$t('ui.created_by')") {{ $t('ui.created_by') }}
                th.text-right.sortable(width="13%" @click="sortOrder('created_date')")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
            tbody.clusterize-content
              tr(v-if="gameExcludeList.length == 0")
                td(:colspan="5").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in gameExcludeList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.game_name") {{ item.game_name }}
                  .float-right
                    a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="onDelete(item)" :title="$t('ui.delete')")
                td
                  span(:title="item.provider_code") {{ item.provider_code }}
                td
                  span(:title="item.created_by") {{ item.created_by }}
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

    addgamenameexclude(ref="addgamenameexclude" @clicked="afterAddGameNameExclude" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ProviderLookup from "@/library/ProviderLookup.vue";
import addgamenameexclude from "@/components/setup/addGameNameExclude.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ProviderLookup,
    addgamenameexclude
  },
  data: () => ({
    loading: false,
    gameExcludeList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    provider_code: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortType: "asc",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_gamenameexclude");
    }
  },
  mounted: function() { },
  methods: {
    refresh() {
      this.getGameNameExcludeList(true)
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getGameNameExcludeList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getGameNameExcludeList: function(isSearch) {
      let url = config.gameNameExcludeListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.game_name = this.search;

      if (this.provider_code.trim() != '')
        json.provider_code = this.provider_code;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.gameExcludeList = response.data.dt;
                this.totalRow = this.gameExcludeList.length > 0 ? this.gameExcludeList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    afterAddGameNameExclude: function() {
      this.search = "";
      this.currentPage = 1;
      this.getGameNameExcludeList(true);

      this.$helpers.showDialog(this.$t("ui.combine.add_game_exclude"), this.$t("message.success"), "success");
    },
    onDelete: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.delete_game_exclude_confirm", { name: item.game_name, provider: item.provider_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDelete(item);
          }
        });
    },
    confirmDelete: function(item) {
      let url = config.gameNameExcludeRemoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        game_name: item.game_name,
        provider_code: item.provider_code,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getGameNameExcludeList();
                this.$helpers.showDialog(this.$t("ui.combine.delete_game_exclude"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeGameNameExclude", pageSize);
      this.currentPage = 1;
      this.getGameNameExcludeList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getGameNameExcludeList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>